import { LessonType, OfferItem } from '@opanuj/shared/types';
import { ref } from 'firebase/database';
import { useDatabase } from './useDatabase';
import { useListKeys, useListVals, useObjectVal } from 'react-firebase-hooks/database';
import { withDefaultList, withDefaultObject } from './defaults';

const normalizeLessonType = (s: string): LessonType | undefined => {
	const options = new Map([
		[LessonType.KI, ['ki', 'korepetycje indywidualne']],
		[LessonType.KG, ['kg', 'korepetycje grupowe']],
		[LessonType.K8, ['k8', 'kurs ósmoklasisty']],
		[LessonType.KM, ['km', 'kurs maturalny']],
		[LessonType.WS, ['ws', 'warsztaty']],
	])
	for (const [lt, vals] of options)
		if (vals.includes(s.toLocaleLowerCase())) return lt
	return undefined
}

const offerOptions = {
	transform: (val: any) => ({ ...val, type: normalizeLessonType(val.type)})
}

const offerListOptions = {
	transform: (val: any) => {
		let result: {[key: string]: OfferItem} = {}
		for (const offer in val) {
			result[offer] = { ...val[offer], type: normalizeLessonType(val[offer].type)}
		}
		return result
	}
}

export const useOfferList = () => {
	const database = useDatabase();
	const [offer, loading, error] = useListVals<OfferItem>(ref(database, 'offer'), offerOptions);
	return [withDefaultList(offer), loading, error] as const;
}

export const useOffer = () => {
	const database = useDatabase();
	const [offer, loading, error] = useObjectVal<{ [code: string]: OfferItem }>(ref(database, 'offer'), offerListOptions);
	return [withDefaultObject(offer), loading, error] as const;
}

export const useOfferListKeys = () => {
	const database = useDatabase()
	return useListKeys(ref(database, 'offer'));
}